import { useRouter } from "next/router";

import CategoryEditor from "../../components/category/categoryEditor";
import Layout from "../../components/layouts/layout.comp";
import { EditingMode } from "../../components/reuseables/form.comp";
import { useTranslation } from "../../core/translation.core";

export default function CategoryCreatePage() {
  const { t, msg } = useTranslation();
  const router = useRouter();

  return (
    <Layout title={t(msg.category.add)}>
      <section className="pb-32">
        <CategoryEditor editingMode={EditingMode.create} categoryId={router.query.id as string} />
      </section>
    </Layout>
  );
}
